module.exports = __webpack_public_path__ + "static/media/add-member.b9df88a1.svg";